import React from "react";

export const rataplanPublishedAT = (
  <span className="white">
    <i>El país de Lilac</i> (1938), <i>Cuentos tricolores</i> (1967) y <i>Retorno a Lilac</i> (1967)
  </span>
);
